import { render, staticRenderFns } from "./ChooseProject.vue?vue&type=template&id=1bfb45aa&scoped=true"
import script from "./ChooseProject.vue?vue&type=script&lang=js"
export * from "./ChooseProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb45aa",
  null
  
)

export default component.exports